import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../api/api";
import { setAuth } from "../api/auth";
import { useLanguage } from "../i18n/LanguageContext";

function AdminLogin() {
  const { t } = useLanguage();
  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await API.get("/api/auth/me", {
        auth: {
          username: credentials.email,
          password: credentials.password,
        },
      });

      if (response.data.role !== "ADMIN") {
        setError(t("adminLogin.notAdmin"));
        return;
      }

      setAuth(credentials.email, credentials.password, response.data.role);
      navigate("/admin");
    } catch (err) {
      setError(t("adminLogin.invalid"));
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <div className="form-container">
      <h2>{t("adminLogin.title")}</h2>
      <form onSubmit={handleSubmit}>
        {error && <p className="checkout-error">{error}</p>}
        <input
          name="email"
          placeholder={t("adminLogin.email")}
          type="email"
          value={credentials.email}
          onChange={handleChange}
          required
        />
        <div style={{ position: "relative" }}>
          <input
            name="password"
            placeholder={t("adminLogin.password")}
            type={showPassword ? "text" : "password"}
            value={credentials.password}
            onChange={handleChange}
            required
            style={{ paddingRight: "50px" }}
          />
          <span className="toggle-password" onClick={togglePasswordVisibility}>
            {showPassword ? t("adminLogin.hide") : t("adminLogin.show")}
          </span>
        </div>
        <button type="submit">{t("adminLogin.submit")}</button>
      </form>
    </div>
  );
}

export default AdminLogin;
